import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal,UncontrolledDropdown, UncontrolledTooltip, DropdownToggle,DropdownMenu, Table } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS1, formatDate, downloadBase64File, getContentTypeFromBase64, TOAST_OPTIONS3 } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';
import Swal from 'sweetalert2';

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import { useParams } from 'react-router-dom';
import {Link} from 'react-router-dom';
import { classname } from 'classnames';

    const AddPaymentRequisition = () => {
        const history = useHistory();
        const {id} = useParams();

        const [inputs, setInputs] = useState([]);
        const [empTitle, setEmpTitle] = useState('');
        const [requisitionerNo, setRequisitionerNo] = useState('')
        const [employeeNo1, setEmployeeNo1] = useState('')

        const [subCategories, setSubCategories] = useState([])
        const [payeeOptions, setPayeeOptions] = useState([])
        const [currencyList, setCurrencyList] = useState([])
        const [accType, setAccType] = useState(['G/L Account', 'Vendor', 'Customer', 'Bank Account'])
       
        const [selectedPayee, setSelectedPayee] = useState('')
        const [paymentCategory, setPaymentCategory] = useState('')
        const [paymentSubCategory, setPaymentSubCategory] = useState('')
        const [purpose, setPurpose] = useState('')
        const [cancellationcomment, setCancellationComment] = useState('')
        const [currencyCode, setCurrencyCode] = useState('')
        const [projectCode, setProjectCode] = useState('')
        const [payeeNo, setPayeeNo] = useState('')
        const [payeeName, setPayeeName] = useState('')
        const [approverCode, setApproverCode] = useState('')
        const [amount, setAmount] = useState('')
        const [amountLCY, setAmountLCY] = useState('')
        const [no, setNo] = useState('')
        const [status, setStatus] = useState('')

        const [etag, setEtag] = useState('')
        const [systemId, setSystemId] = useState('')

        const [selectedType, setSelectedType] = useState('')
        const [selectedNox, setSelectedNox] = useState('')
        const [description, setDescription] = useState('')
        const [lineEtag, setLineEtag] = useState('')


        const [paymentRequisitionLines, setPaymentRequisitionLines] = useState([])

        const [noo, setNoo] = useState([])
        const [noo1, setNoo1] = useState([])

        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [showPayeeNo, setShowPayeeNo] = useState(false)

        const [modal_line, setmodal_line] = useState(false);
        const [modal_applyEntries, setmodal_applyEntries] = useState(false);
        const [isEdit, setIsEdit] = useState(false)
        const [editLine, setEditLine] = useState(false);
        const [addDetails, setAddDetails] = useState(false);
        const [managementActivities, setManagementActivities] = useState([])

        const [rNo, setRNo] = useState("")
        const [departmentcode, setDepartmentCode] = useState('')
        const [RStatus, setRStatus] = useState("")
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [CompanyID, setCompanyID] = useState("")

        const [payeeType, setPayeeType] = useState('')
        const [selectedNo, setSelectedNo]= useState('')
        const [selectedNo2, setSelectedNo2]= useState('')
        const [workplanno, setWorkPlanNo] = useState("") 
        const [workplans, setWorkPlans] = useState([]) 
        const [transactionTypeslist, setTransactionTypesList] = useState([]) 
        const [externalDocumentNo, setExternalDocumentNo] = useState("")
        const [activityStartDate, setActivityStartDate] = useState("")
        const [activityEndDate, setActivityEndDate] = useState("")

        const [accountType, setAccountType] = useState("")
        const [accountNo, setAccountNo] = useState("")
        const [accountName, setAccountName] = useState("")
        const [customers, setCustomers] = useState([])
        const [wkPlanGLAccounts, setWorkPlanGLAccounts] = useState([])
        const [nonwkPlanGLAccounts, setNonWorkPlanGLAccounts] = useState([])
        const [bankAccounts, setBankAccounts] = useState([])
        const [workPlanEntry, setWorkPlanEntry] = useState([])
        const [fundsourceDim, setFundSourceDim] = useState([])
        const [narration, setNarration] = useState("")
        const [rate, setRate] = useState(0)
        const [quantity, setQuantity] = useState("")
        const [workPlanEntryNo, setWorkPlanEntryNo] = useState("")
        const [whtpercentage, setWHTPercentage] = useState("")
        const [whtamount, setWHTAmount] = useState("")
        const [lineSystemId, setLineSystemId] = useState("")
        const [whtAmountOnVAT, setWHTAmountonVAT] = useState("")
        const [vatAmount, setVATAmount] = useState("")
        const [amountToPay, setAmounttoPay] = useState("")
        const [amountPaid, setAmountPaid] = useState("")
        const [noOfInstallments, setNoofInstallments] = useState("")
        const [installmentAmount, setInstallmentAmount] = useState("")
        const [fundsource, setFundSource] = useState("")

        const [applnID, setApplnID] = useState("")
        const [applyEntry, setApplyEntry] = useState(false)
        const [applnPostingDate, setApplnPostingDate] = useState("")
        const [applnDocumentType, setApplnDocumentType] = useState("")
        const [applnDocumentNo, setApplnDocumentNo] = useState("")
        const [applnExtDocNo, setApplnExtDocNo] = useState("")
        const [applnDescription, setApplnDescription] = useState("")
        const [applnCurrencyCode, setApplnCurrencyCode] = useState("")
        const [remainingAmount, setRemainingAmount] = useState("")
        const [applnReminingAmount, setApplnRemainingAmount] = useState("")
        
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }
        const tog_applyEntries = () => {
            axios.get(`${url.VENDORLEDGERENTRIES}?$filter=vendorNo eq '${payeeNo}' &company='${CompanyID}'`, HRConfig).then((r)=>{ 
                setManagementActivities(r.data.value) 
            }).catch((e)=>{
                console.log(e)
            })
            setmodal_applyEntries(!modal_applyEntries);
            removeBodyCss();
        }
        const tog_history = () => {
            setmodal_history(!modal_history);
            removeBodyCss();
        }
        const tog_attachments = () => {
            setmodal_attachments(!modal_attachments);
            removeBodyCss();
        }

        toastr.options = TOAST_OPTIONS3;
        const updatePayeeType = (e) => {
            let req = {}
            req = {
                requisitioner   :   empNo,
                payeeType       :   e.target.value,
            }
            let newPType = e.target.value
            if ((e.target.value != payeeType) && (paymentRequisitionLines.length > 0)){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "Modifying the Payee type will delete all associated payment requisition lines. This action is irreversible. Do you wish to proceed?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#019654',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.isConfirmed){
                        setIsloading(true)
                        const Config = {
                        auth:{
                            username: url.HRMIS,
                            password: url.HRMISPASS,
                            },
                        headers:{
                            'Content-Type': 'application/json',
                            'If-Match'    : '*'
                            }
                        }
                        axios.get(`${url.PMTREQNLINES}?$filter=documentNo eq '${rNo}' &company=${CompanyID}`, Config)
                        .then((res) => {   
                            let resObj = res.data.value;
                            resObj.forEach((obj, index) => {
                                console.log(resObj)
                                const Config = {
                                    auth: {
                                        username: url.HRMIS,
                                        password: url.HRMISPASS
                                    },
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'If-Match'    : '*'
                                    }
                                }
                                axios.delete(`${url.PMTREQNLINES}(${obj.id})?company=${CompanyID}`, Config)
                                .then((response) => {
                                    setIsloading(false)                            
                                    setPayeeType(newPType)                         
                                    prepareTransactionType(newPType) 
                                    setPayeeNo('')
                                    setPayeeName('')
                                    setWorkPlanNo('')
                                    setSelectedNo2('')
                                    axios.patch(`${url.PAYMENTS1}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                                    .then(function(response){     
                                        if(response.status == '200'){
                                            toastr.info("Saving..." );
                                            setPayeeType(newPType) 
                                            setPayeeNo('')
                                            setPayeeName('')
                                            setWorkPlanNo('')
                                            setSelectedNo2('')
                                            history.go('0')
                                            toastr.success("Saved" );
                                        }else{
                                            toastr.error("Could not save Payee type" )
                                        }
                                        setIsloading(false)
                                        preparePayeeNo(payeeType)
                                        getData()
                                        history.go('0')
                                    })
                                    .catch(function (error) {
                                        toastr.error(error.response.data.error.message);
                                        setIsloading(false)
                                        console.log(error)
                                        })
                                    }).catch((error) => {
                                        toastr.error(error.response.data.error.message);
                                        setIsloading(false)
                                    })
                                })
                                if (resObj.length == 0){
                                    toastr.info("Payment requisition Lines have been cleared. You can now create new lines.");
                                    setIsloading(false)              
                                    setPayeeType(newPType)                         
                                    prepareTransactionType(newPType) 
                                    setPayeeNo('')
                                    setPayeeName('')
                                    setWorkPlanNo('')
                                    setSelectedNo2('')
                                    history.go('0')
                                    }
                                }).catch((error)=>{
                                toastr.error(error.response.data.error.message)
                                console.log(error)
                                setIsloading(false)
                             })        
                        }
                    }
                )
            }
                     
            if ((payeeType == '') && (paymentRequisitionLines.length == 0)){              
                toastr.info("Saving...")
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.post(url.PAYMENTS1 +"?company="+ CompanyID, JSON.stringify(req), HRConfig)             
                    .then(function(response){     
                        if(response.status == '201'){
                            history.push(`/payment-requisition-details/${response.data.id}`)
                            toastr.success("Saved" ); 
                        }else{
                            toastr.error("Could not save Payee type" )
                        }
                        setIsloading(false)
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setIsloading(false)
                    }
                )
            }
        }

        useEffect(() => {
            if (localStorage.getItem("authMildUser")) {
                const obj = JSON.parse(localStorage.getItem("authMildUser"));
                const EmployeeNo = obj.uid;
                setCompanyID(obj.activeCompany); 
                axios.get(url.EMPLOYEES2 + "?$filter=No eq '"+ EmployeeNo +"'&company="+ obj.activeCompany, HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                            setDepartmentCode(response.data.value[0].Department_Code);
                            setUserError(false);
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setUserError(true);
                        console.log(error);
                })
                    
            }
        },[]);

        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Payment Requisition | {url.APPNAME}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Payment Management" breadcrumbItem="Payment Requisition" />
                        <div>
                     

                        {(ipaSaved == false) ? (
                        <Row>
                            <Col xl={4}>
                                <Card>
                                    <CardBody>
                                        <CardTitle>Employee Details</CardTitle>
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="col"> Number</th>
                                                            <td scope="col"> {empNo} </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col"> Name</th>
                                                            <td scope="col">{empName}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Position</th>
                                                            <td scope="col">{empTitle}</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Department</th>
                                                            <td scope="col">{departmentcode}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>                                                      
                                    </CardBody>
                                </Card>
                                <div className="d-flex">
                                    <div className="flex-grow-1 ms-1">                                 
                                        <ul className="list-unstyled vstack gap-2 mb-0">
                                            <div className="d-grid gap-2">
                                                {/* {(RStatus == 'Open') && (payeeType != 'Vendor') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}  */}
                                                {(RStatus == 'Open') && (payeeType == 'Vendor') && (selectedNo != '') && (selectedNo2 != '') && (paymentRequisitionLines.length < 1) && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Staff') && (selectedNo != '') && (selectedNo2 != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Staff') && ((selectedNo == 'SALARIES') || (selectedNo == 'SPECIALISTS')) && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Subgrantee') && (workplanno != '') && (selectedNo != '') && (selectedNo2 != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Statutory Bodies') && (selectedNo != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'OVC') && (selectedNo != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Participants') && (selectedNo != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Bank Transfers') && (selectedNo != '') && (selectedNo2 != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Salary Advance') && (selectedNo != '') && (selectedNo2 != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (
                                                    <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDelete()}} >
                                                        <i className="mdi mdi-delete"/>{" "}
                                                            Delete Payment Requisition
                                                    </Button>
                                                )}
                                                {(paymentRequisitionLines.length > 0) && (RStatus == 'Open') && (
                                                    <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleApprovalRequest}>
                                                        <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                            Submit Payment Requisition for Approval
                                                    </Button>
                                                )}
                                                {(RStatus == 'Pending Approval') && (
                                                    <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleCancelApprovalRequest}>
                                                        <i className="mdi mdi-book-cancel-outline"/>{" "}
                                                            Cancel Approval Request
                                                    </Button>
                                                )}
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                            <Col  xl={8}>
                                <Card>
                                    <CardBody>
                                        <CardTitle>Requisition Details</CardTitle>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Payee Type</label>
                                                    <select className="form-select" 
                                                        value={payeeType} 
                                                        onChange={(e)=>updatePayeeType(e)}
                                                    >
                                                        <option value=" ">Select</option>
                                                        <option value="Staff">Staff</option>
                                                        <option value="Vendor">Vendor</option>
                                                        <option value="Subgrantee">Subgrantee</option>
                                                        <option value="Statutory Bodies">Statutory Bodies</option>
                                                        <option value="OVC">OVC</option>
                                                        <option value="Participants">Participants</option>
                                                        <option value="Bank Transfers">Bank Transfers</option>
                                                        <option value="Salary Advance">Salary Advance</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            {((payeeType == 'Staff')||(payeeType == 'Vendor')||(payeeType == 'Subgrantee')||(payeeType == 'Statutory Bodies')||(payeeType == 'OVC')||(payeeType == 'Participants')||(payeeType == 'Bank Transfers')||(payeeType == 'Salary Advance')) && (
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Transaction Type</label>
                                                        <div className="form-floating mb-3">
                                                            <select className="form-select" 
                                                                value={selectedNo}                                                                 
                                                                onChange={(e)=>updateTransactionType(e)}
                                                                disabled={(RStatus=='Open')?false:true}
                                                            > 
                                                            <option value=''>Select</option>
                                                                { transactionTypeslist.map((l,k)=>( <option key={k} value={l.no}>{l.description}
                                                            </option> ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                            {((payeeType == 'Staff')||(payeeType == 'Vendor')||(payeeType == 'Subgrantee')||(payeeType == 'Statutory Bodies')||(payeeType == 'OVC')||(payeeType == 'Participants')||(payeeType == 'Bank Transfers')||(payeeType == 'Salary Advance')) && ((selectedNo == 'SALARIES')||(selectedNo != 'SPECIALISTS')) && (RStatus == 'Open') && (
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Select Payee</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo1} 
                                                                value={noo1.find((option) => option.value === selectedNo2)} 
                                                                onChange={(p)=>handleSelectedPayee(p)}
                                                                disabled={(RStatus=='Open')?false:true}
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                            )} 
                                            {(RStatus == 'Open') && (                                          
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Payee No.</label>
                                                        <input  type="text" 
                                                            className="form-control" 
                                                            defaultValue={selectedNo2}
                                                            disabled={(RStatus=='Open') && ((selectedNo != 'SALARIES') || (selectedNo != 'SPECIALISTS'))?true:false}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && ( 
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Payee Name</label>
                                                        <input  type="text" 
                                                            className="form-control" 
                                                            value={payeeName} 
                                                            onChange={(e)=>setPayeeName(e.target.value)}
                                                            disabled={(RStatus=='Open') && (selectedNo != 'SALARIES') && (selectedNo != 'SPECIALISTS')?true:false}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus != 'Open') && (                                          
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Payee No.</label>
                                                        <input  type="text" 
                                                            className="form-control" 
                                                            defaultValue={selectedNo2}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus != 'Open') && ( 
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Payee Name</label>
                                                        <input  type="text" 
                                                            className="form-control" 
                                                            value={payeeName} 
                                                            onChange={(e)=>setPayeeName(e.target.value)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </Col>
                                            )}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Work Plan No.</label>
                                                    <select className="form-select" 
                                                        value={workplanno} 
                                                        onChange={(e)=>handleChangeWorkPlanNo(e)}
                                                        disabled={(RStatus=='Open')?false:true}
                                                        > 
                                                        <option value=''>Select</option>
                                                            { workplans.map((l,k)=>( <option key={k} value={l.no}>{l.no}
                                                        </option> ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>External Document No.</label>
                                                    <input type='text' 
                                                        className="form-control" 
                                                        value={externalDocumentNo} 
                                                        onChange={(e)=>setExternalDocumentNo(e.target.value)}
                                                        disabled={(RStatus=='Open')?false:true}
                                                    />
                                                </div>
                                            </Col>
                                            {(RStatus == 'Open') && ( 
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Activity Start Date</label>
                                                        { <Flatpickr
                                                            className="form-control"
                                                            value={activityStartDate}
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d"
                                                            
                                                            }}
                                                        /> }
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && ( 
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Activity End Date</label>
                                                        { <Flatpickr
                                                            className="form-control"
                                                            value={activityEndDate}
                                                            onChange={(e)=>updateActivityEndDate(formatDate(e))}                       
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d"

                                                            }}
                                                        /> }
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus != 'Open') && ( 
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Activity Start Date</label>
                                                        { <Flatpickr
                                                            className="form-control"
                                                            value={activityStartDate}
                                                            onChange={(e)=>updateActivityStartDate(formatDate(e))}  
                                                            disabled={true}                     
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d"
                                                            
                                                            }}
                                                        /> }
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus != 'Open') && ( 
                                                <Col md={6}>
                                                    <div className="mb-3">
                                                        <label>Activity End Date</label>
                                                        { <Flatpickr
                                                            className="form-control"
                                                            value={activityEndDate}
                                                            onChange={(e)=>updateActivityEndDate(formatDate(e))} 
                                                            disabled={true}                      
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d"
                                                            }}
                                                        /> }
                                                    </div>
                                                </Col>
                                            )}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <label>Currency Code</label>
                                                    <select className="form-select" 
                                                        value={currencyCode}                                                                 
                                                        onChange={(e)=>updatecurrencyCode(e)}
                                                        disabled={(RStatus=='Open')?false:true}
                                                        > 
                                                        <option value=''>Select</option>
                                                            { currencyList.map((l,k)=>( <option key={k} value={l.code}>{l.code}
                                                        </option> ))}
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Purpose</label>
                                                    <textarea
                                                        type="text" 
                                                        className="form-control"
                                                        rows={2} 
                                                        value={purpose} 
                                                        onChange={(e)=>setPurpose(e.target.value)} 
                                                        disabled={(RStatus=='Open')?false:true}
                                                    />
                                                </div>
                                            </Col>
                                            
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            

                                <Col>        
                                    <Modal isOpen={modal_line} toggle={() => { tog_line() }} size="xl" centered  backdrop={'static'} >
                                    <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update/Delete `:`Add ` }Payment Requisition Line</h5>
                                        <button type="button"
                                            onClick={() => { setmodal_line(false)}}
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">     
                                        <Row >
                                            {(payeeType == 'Vendor') && (
                                                <Col lg={6}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange(e)}}
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="Vendor">Vendor</option>
                                                        </select>
                                                    </div>   
                                                </Col>
                                            )}
                                            {(payeeType == 'Staff') && ((selectedNo == 'BUSINESS ADVANCE') || (selectedNo == 'PERDIEM') || (selectedNo == 'PREPAID EXPENSE') || (selectedNo == 'REFUNDS') || (selectedNo == 'VOLUNTEER')) && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="G/L Account">G/L Account</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'OVC') && (workplanno != '') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="G/L Account">G/L Account</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'Salary Advance') && (workplanno != '') && (selectedNo != '') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="G/L Account">G/L Account</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'Participants') && (workplanno != '') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="G/L Account">G/L Account</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'Staff') && ((selectedNo == 'SALARIES') || (selectedNo == 'SPECIALISTS')) && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange3(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="None Workplan- G/L">None Workplan- G/L</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'Statutory Bodies') && (selectedNo != '') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange3(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="None Workplan- G/L">None Workplan- G/L</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'Subgrantee') && (selectedNo != '') && (workplanno != '') && (selectedNo2 != '') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange4(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="Customer">Customer</option>
                                                            <option value="G/L Account">G/L Account</option>
                                                            <option value="None Workplan- G/L">None Workplan- G/L</option>
                                                            <option value="Bank Account">Bank Account</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(payeeType == 'Bank Transfers') && (selectedNo != '') && (selectedNo2 != '') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Type</label>
                                                        <select className="form-select"  
                                                            value={accountType}
                                                            onChange={(e) =>{handleAccountTypeChange5(e)}}                                                        
                                                            disabled={(RStatus=='Open')?false:true}
                                                        >
                                                            <option value=" ">Select</option>
                                                            <option value="Bank Account">Bank Account</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'Staff') && ((accountType != '') || (accountType != " ")) && ((selectedNo == 'BUSINESS ADVANCE') || (selectedNo == 'PERDIEM') || (selectedNo == 'PREPAID EXPENSE') || (selectedNo == 'REFUNDS') || (selectedNo == 'VOLUNTEER') || (selectedNo == 'SALARIES') || (selectedNo == 'SPECIALISTS')) && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3"
                                                        disabled={(RStatus=='Open')?false:true}>
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'Bank Transfers') && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'Salary Advance') && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'Subgrantee') && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'OVC') && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'Participants') && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (payeeType == 'Statutory Bodies') && (   
                                                <Col lg={4}>
                                                    <label htmlFor="floatingSelectGrid">Account Name</label>
                                                        <div className="form-floating mb-3">
                                                            <Select options={noo} 
                                                                value={noo.find((option) => option.value === accountNo)} 
                                                                onChange={handleNoChange} 
                                                            />
                                                        </div>
                                                </Col>
                                            )}
                                            {(accountType == 'Vendor') && (
                                                <Col lg={6}>
                                                    <div className="mb-3">
                                                        <label>Account No </label>
                                                        <input className="form-control" 
                                                            value={accountNo} 
                                                            disabled={true} />   
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus == 'Open') && (accountType == 'Vendor') && (
                                                <Col lg={12}>
                                                    <div className="mb-3">
                                                        <label>Account Name </label>
                                                        <input className="form-control" 
                                                            value={accountName} 
                                                            disabled={true} />   
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus != 'Open') && (accountType == 'Vendor') && (
                                                <Col lg={12}>
                                                    <div className="mb-3">
                                                        <label>Account Name </label>
                                                        <input className="form-control" 
                                                            value={accountName} 
                                                            disabled={true} />   
                                                    </div>
                                                </Col>
                                            )}
                                            {(RStatus != 'Open') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account Name </label>
                                                        <input className="form-control" 
                                                            value={accountName} 
                                                            disabled={true} />   
                                                    </div>
                                                </Col>
                                            )}
                                            {(accountType != 'Vendor') && (
                                                <Col lg={4}>
                                                    <div className="mb-3">
                                                        <label>Account No. </label>
                                                        <input className="form-control" 
                                                            value={accountNo} 
                                                            disabled={true} />   
                                                    </div>
                                                </Col>
                                            )}
                                            {(accountType != 'Vendor') && (
                                                <Col lg={4} className="mb-3">
                                                    <label htmlFor="floatingSelectGrid">Workplan Entry No</label>
                                                    <select className="form-select" value={workPlanEntryNo} onChange={(e)=>setWorkPlanEntryNo(e.target.value)} disabled={(RStatus=='Open')?false:true}> 
                                                        <option value=''>Select</option>
                                                            { workPlanEntry.map((l,k)=>( <option key={k} 
                                                                value={l.entryNo}>{l.entryNo}
                                                        </option> ))}
                                                    </select>
                                                </Col>
                                            )}
                                            {(accountType != 'Vendor') && (
                                                <Col lg={8}> 
                                                    <label htmlFor="floatingSelectGrid">Narration</label>
                                                        <div className="mb-3">
                                                            <input  type="text" className="form-control" value={narration} onChange={(e)=>setNarration(e.target.value)} disabled={(RStatus=='Open')?false:true}  />
                                                        </div>
                                                </Col>
                                            )}
                                            {(accountType == 'Vendor') && (
                                                <Col lg={12}>
                                                    <label htmlFor="floatingSelectGrid">Narration</label>
                                                        <div className="mb-3">
                                                            <input  type="text" className="form-control" value={narration} onChange={(e)=>setNarration(e.target.value)} disabled={(RStatus=='Open')?false:true}  />
                                                        </div>  
                                                </Col>
                                            )}
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Quantity</label>
                                                    <div className="mb-3">  
                                                        <input  type="number" className="form-control" value={quantity}  onChange={(e)=>{ setQuantity(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                    </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Rate</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={rate} onChange={(e)=>{ setRate(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Amount</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={amount} disabled={true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Amount LCY</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={amountLCY} disabled={true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">WHT Percentage</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={whtpercentage} onChange={(e)=>{ setWHTPercentage(e.target.value)}} disabled={true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">WHT Amount</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={whtamount} onChange={(e)=>{ setWHTAmount(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">WHT Amount on VAT</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={whtAmountOnVAT} onChange={(e)=>{ setWHTAmountonVAT(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">VAT Amount</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={vatAmount} onChange={(e)=>{ setVATAmount(e.target.value)}} disabled={true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Amount to Pay</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={amountToPay} onChange={(e)=>{ setAmounttoPay(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Amount Paid</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={amountPaid} onChange={(e)=>{ setAmountPaid(e.target.value)}} disabled={true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">No. of Installments</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={noOfInstallments} onChange={(e)=>{ setNoofInstallments(e.target.value)}} disabled={true} />
                                                </div>
                                            </Col>
                                            <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Installment Amount</label>
                                                <div className="mb-3">
                                                    <input  type="number" className="form-control" value={installmentAmount} onChange={(e)=>{ setInstallmentAmount(e.target.value)}} disabled={true} />
                                                </div>
                                            </Col>
                                            {/* <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Fund Source</label>
                                                <div className="mb-3">
                                                    <Select options={fundsourceDim} 
                                                        value={fundsourceDim.find((option) => option.value === fundsource)} 
                                                        onChange={handleFundsourcechange} 
                                                    />
                                                </div>
                                            </Col> */}
                                        </Row>
                                    </div>
                                    <div className="modal-footer">
                                        <div className="hstack gap-2 mb-0">
                                            {(payeeType == 'Vendor') && (
                                            <Button color="info" type="button" className="btn btnSubmitPlan" onClick={()=>{tog_applyEntries()}} >
                                                <i className="mdi mdi-cash-refund"/>{" "}
                                                    Apply Entries
                                            </Button>
                                            )}
                                            {isEdit && (RStatus == 'Open') && (
                                            <Button color="success" type="button" className="btn btnSubmitPlan" onClick={handleUpdateLine}>
                                                <i className="mdi mdi-book-outline"/>{" "}
                                                Update Line
                                            </Button>
                                            )}
                                            {!isEdit && (RStatus == 'Open') && (
                                            <Button color="success" type="button" className="btn btnSubmitPlan" onClick={handleAddLine2}>
                                                <i className="mdi mdi-save"/>{" "}
                                                Save Line details...
                                            </Button>
                                            )}
                                            {(RStatus == 'Open') && (
                                                <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDeleteLine2()}} >
                                                    <i className="mdi mdi-delete"/>{" "}
                                                        Delete line
                                                </Button>
                                            )}
                                        </div>                                             
                                    </div>
                                </Modal>

                                {/* EHUB LOOK ALIVE */}
                                <Modal isOpen={modal_applyEntries} toggle={() => { tog_applyEntries(); }}  size="xl" centered  backdrop={'static'}  >
                                    <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">Apply Vendor Entries - {payeeNo} · {payeeName}</h5>
                                        <button type="button"  onClick={() => { setmodal_applyEntries   (false) }}  className="close" data-dismiss="modal"aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                  </div>
                                  <div className="modal-body">
                                    <Row >
                                        {(RStatus == 'Open') && addDetails && (
                                        <>
                                        <Col lg={3}>
                                            <div className="mb-3">
                                                <label>Select Entry</label>
                                                <select className="form-select" 
                                                    value={applyEntry? 'true' : 'false'} 
                                                    onChange={(e)=>updateApplyEntry(e)}
                                                    disabled={(RStatus=='Open')?false:true}
                                                >
                                                    <option value={``}>Select</option>
                                                    <option value={true}>Yes</option>
                                                    <option value={false}>No</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label>Posting Date</label>
                                            <div className="form-floating mb-3">
                                                <Flatpickr
                                                    className="form-control"
                                                    disabled={true}
                                                    placeholder="dd M,yyyy"
                                                    options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d"
                                                    }}
                                                    value={applnPostingDate}
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Document Type</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={applnDocumentType}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Document No.</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={applnDocumentNo}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">External Document No.</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={applnExtDocNo}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Currency Code</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={applnCurrencyCode}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Remaining Amount</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={remainingAmount}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>
                                        <Col lg={3}>
                                            <label htmlFor="floatingSelectGrid">Application Remaining Amount</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={applnReminingAmount}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>
                                        <Col lg={12}>
                                            <label htmlFor="floatingSelectGrid">Description</label>
                                                <div className="form-floating mb-3">
                                                    <input type="text" 
                                                        className="form-control" 
                                                        value={applnDescription}
                                                        disabled={true}  
                                                    />
                                                </div>
                                        </Col>                                        
                                        </>
                                        )}
                                        <Col sm={12}>
                                            <h5 className="text-primary">- View details</h5>
                                            <hr/>
                                        </Col>
                                        <Col lg={12}>
                                            {(managementActivities.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table  className="table table-striped table-wrap table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th>Select Entry</th>
                                                            <th>Applies-to ID</th>
                                                            <th>Posting Date</th>
                                                            <th>Document Type</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Document No.</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Ext. Document No.</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Description</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Currency</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Remaining Amt</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Application Remaining Amt</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Action</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {managementActivities.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>
                                                                    {a.applyEntry ? <i className='mdi mdi-check'></i> : <i className='mdi mdi-close'></i>}
                                                                </td>
                                                                <td>{a.appliesToID}</td>
                                                                <td>{a.postingDate}</td>
                                                                <td>{a.documentType}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.documentNo}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.externalDocNo}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.description}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.curCode}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.remainingAmount}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.applnremainingAmount}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                    
                                                                {(RStatus == 'Open') && (
                                                                    <div className="d-flex gap-3">
                                                                        <Link
                                                                            to="#"
                                                                            className="text-success"
                                                                            onClick={() => handleEditManagement(k)}
                                                                        >
                                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                            <UncontrolledTooltip placement="top" target="edittooltip">
                                                                                Edit
                                                                            </UncontrolledTooltip>
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                                </></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-cash-refund text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No Vendor Ledger Entries found</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                        <Row className='justify-content-center'>
                                            {(managementActivities.length > 0) && (
                                                <>
                                                    <Col md={6} className='mb-4 mt-3'>
                                                        <div className="d-grid">
                                                            <Button color="primary" type="button" className="btn-rounded" onClick={handleAppliestoID}>
                                                                Set Applies-to ID
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                    <Col md={6} className='mb-4 mt-3'>
                                                        <div className="d-grid">
                                                            <Button color="warning" type="button" className="btn-rounded" onClick={handleUnapplyEntries}>
                                                                Un-Apply Entries
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </>
                                            )}
                                        </Row>
                                     </Row>
                                  </div>
                                </Modal>                
                            <br/>
                        </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Requisition <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
            </LoadingOverlay>
        );
    }

export default AddPaymentRequisition;